<template>
  <div class="image-preview">
    <div ref="images" class="preview-list" v-viewer='{rotatable: true,scalable: false}'>
      <!--<div class="item-inline" v-if="images.length" v-for="src in images" :key="src.id">-->
      <span v-if="(!images.length)&&(!isHomePage)">无</span>
      <img class="item-inline item_image" v-if="(!images.length)&&(isHomePage)" src="https://cloud-prana.oss-cn-hangzhou.aliyuncs.com/cms/content/case/cfac7444185346869e716a803612d4c7.jpg?x-oss-process=image/quality,Q_90"/>
      <div class="item_inline_noborder" v-if="images.length" v-for="src in images">
        <div v-if="canCheck" @click="toCheckImg(src)">
          <i class="el-icon-success checked-icon" v-if="hasCheck(src)"></i>
          <i class="uncheck-icon" v-else></i>
        </div>
        <img class="item_image_border" :key="src.id" :src="src.ossUrl+'?x-oss-process=style/'+quality_level">
        <span class="img-remark">{{src.fileRemark}}</span>
      </div>

      <!--<span class="item_actions">-->
      <!--<span class="item-preview" @click="show"><i class="el-icon-zoom-in"></i></span>-->
      <!--<span class="item-delete"><i class="el-icon-delete"></i> </span>-->
      <!--</span>-->
      <!--</div>-->
    </div>
    <ul class="ul-topline">
      <li class="item-inline" v-for="src in words" :key="src.id">
        <div v-if="canCheck" @click="toCheckImg(src)">
          <i class="el-icon-success checked-icon check-icon-right" v-if="hasCheck(src)"></i>
          <i class="uncheck-icon check-icon-right" v-else></i>
        </div>
        <a :href="src.ossUrl" :download="src.name" target="_blank">
          <img class="icon-img" src="https://clourd-static.oss-cn-hangzhou.aliyuncs.com/wap%2Fimgs%2Fword-iocn.svg">
          <span class="item-size">
        {{src.size?renderSize(src.size):''}}
        </span>
          <div class="ell">
            {{src.name}}
          </div>
        </a>
      </li>
    </ul>
    <ul class="ul-topline">
      <li class="item-inline" v-for="src in excels" :key="src.id">
        <div v-if="canCheck" @click="toCheckImg(src)">
          <i class="el-icon-success checked-icon check-icon-right" v-if="hasCheck(src)"></i>
          <i class="uncheck-icon check-icon-right" v-else></i>
        </div>
        <a :href="src.ossUrl" :download="src.name" target="_blank">
          <img class="icon-img" src="https://clourd-static.oss-cn-hangzhou.aliyuncs.com/wap%2Fimgs%2Fexcel.svg">
          <span class="item-size">
        {{src.size?renderSize(src.size):''}}
        </span>
          <div class="ell">
            {{src.name}}
          </div>
        </a>
      </li>
    </ul>
    <ul class="ul-topline">
      <li class="item-inline" v-for="src in others" :key="src.id">
        <div v-if="canCheck" @click="toCheckImg(src)">
          <i class="el-icon-success checked-icon check-icon-right" v-if="hasCheck(src)"></i>
          <i class="uncheck-icon check-icon-right" v-else></i>
        </div>
        <a :href="src.ossUrl" :download="src.name" target="_blank">
          <img class="icon-img" style="width: 33px"  src="https://clourd-static.oss-cn-hangzhou.aliyuncs.com/wap%2Fimgs%2Ficon_other.svg">
          <span class="item-size">
        {{src.size?renderSize(src.size):''}}
        </span>
          <div class="ell">
            {{src.name}}
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
  import 'viewerjs/dist/viewer.css'
  import Viewer from 'v-viewer'
  import Vue from 'vue'
  // import {isImage, isArray} from '@/utils/index'

  Vue.use(Viewer)

  function isImage(ossUrl) {
    return (ossUrl && /.(jpeg|gif|jpg|png)$/.test(ossUrl.toLowerCase()))
  }
  export default {
    name: 'ImagePreview',
    watch: {
      businessId: function (newVal, oldVal) {
        this.fileList=[]
        this.getData()
      },
      businessIds: function (newVal, oldVal) {
        this.fileList=[]
        this.getData()
      }
    },
    props: {
      isHomePage:{
        default:false
      },
      businessId:{

      },
      businessIds:{

      },
      quality_level:{
        default:'Q99'
      },
        canCheck:{
          type:Boolean,
          default:false
        }
      },
    data() {
      return {
        fileList: [],
          checkedList:[]
      }
    },
    computed: {
      // 分离出图片组
      images: function () {
        const {fileList} = this
        if (Array.isArray(fileList)) {
          return fileList.filter(f => {
            return isImage(f.ossUrl || '')
          })
        }
        return []
      },
      words(){
        return this.fileList.filter(v=>{
          return (v.ossUrl && /.(doc|docx)$/.test(v.ossUrl.toLowerCase()))
        })
      },
      excels(){
        return this.fileList.filter(v=>{
          return (v.ossUrl && /.(xls|xlsx)$/.test(v.ossUrl.toLowerCase()))
        })
      },
      others(){
        return this.fileList.filter(v=>{
          return !(/.(xls|xlsx|doc|docx)$/.test(v.ossUrl.toLowerCase())) && !isImage(v.ossUrl)
        })
      }
    },
    methods: {
        hasCheck(img){
            let id = img.id
            let imgChecked = this.checkedList.find(item => item.id === id)
            return !!imgChecked
        },
        toCheckImg(img){
            if(this.hasCheck(img)){
                let imgCheckedIndex = this.checkedList.findIndex(item => item.id === img.id)
                this.$delete(this.checkedList,imgCheckedIndex)
            }else{
                let imgToAdd = {...img}
                this.$set(imgToAdd,'isCheck',true)
                this.checkedList.push(imgToAdd)
            }
        },
      getData() {
        if (this.businessId) {
          this.$fetchData(this.$api.imageFile.getImages + "&businessIds=" + this.businessId).then(res => {
            if (res.data) {
              // console.log(res.data,66)
              this.fileList=res.data
              // for (let imgs in res.data) {
              //   this.fileList.push({
              //     id: res.data[imgs].id,
              //     name: res.data[imgs].name,
              //     ossUrl: '/' + res.data[imgs].viewossUrl,
              //     type: res.data[imgs].fileType,
              //     ossossUrl:res.data[imgs].ossossUrl,
              //     status: 'finished'
              //   })
              // }
            }
          })
        }
        if(this.businessIds&&this.businessIds.length){
          for(let uuid of this.businessIds){
            if(uuid){
              this.$fetchData(this.$api.imageFile.getImages + "&businessIds=" + uuid).then(res => {
                if (res.data) {
                  for (let imgs in res.data) {
                    this.fileList.push({
                      id: res.data[imgs].id,
                      name: res.data[imgs].name,
                      ossUrl:res.data[imgs].ossUrl,
                      fileType: res.data[imgs].fileType,
                      status: 'finished'
                    })
                  }
                }
              })
            }

          }
        }
      },
      renderSize(value) {
        if (value === null || value === '') {
          return '0 Bytes'
        }
        const unitArr = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        let index = 0
        let srcsize = parseFloat(value)
        index = Math.floor(Math.log(srcsize) / Math.log(1024))
        let size = srcsize / Math.pow(1024, index)
        //  保留的小数位数
        size = size.toFixed(2)
        return size + unitArr[index]
      }
    },
    created() {
      if(this.businessId){
        // this.fileList=[];
        this.getData()
      }
    },
    activated(){
      if(this.businessId){
        // this.fileList=[];
        this.getData()
      }
    }
  }
</script>

<style scoped lang="scss">
  .checked-icon{
    color:#68c23a;
    font-size: 20px;
    position: absolute;
    top: 5px;
    left: 5px;
    z-index:1;
    &:after{
      content:'';
      width: 10px;
      height:10px;
      background-color: #FFFFFF;
      position: absolute;
      top: 3px;
      left: 4px;
      border-radius: 50%;
      z-index:-1;
    }
  }

  .uncheck-icon{
    position: absolute;
    top: 5px;
    left: 5px;
    background-color: #fff;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #e2e2e2;
  }

  .check-icon-right{
    right:5px;
    left:unset;
  }

  .image-preview {
    min-height: auto;
    margin-top: 10px;
    margin-bottom: 10px;

    .icon-img{
      width: 36px;
    }
    .item_inline_noborder{
      width:150px ;
      display: inline-block;
      margin: 2px;
      position: relative;
      vertical-align: top;
      margin-bottom: 10px;
    }
    .item_image_border{
      width:150px ;
      height: 150px;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      vertical-align: top;
      &:hover{
        border-color: #409EFF;
      }
    }
    .img-remark{
      overflow:hidden;
      text-overflow:ellipsis;
      display:-webkit-box;
      -webkit-line-clamp:1;//想要的行数
      -webkit-box-orient:vertical;
      font-size: 12px;
    }
    .item-inline{
      width:150px ;
      display: inline-block;
      margin: 2px;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      &:hover{
        border-color: #409EFF;
      }
    }
    .item_image{
      height: 150px;
    }
    .item_image_inline{
      width:150px ;
      height: 150px;
    }
    .ell{
      white-space: nowrap;
      text-overflow:ellipsis;
      overflow: hidden;
      font-size: 12px;
      text-indent: 6px;
    }

    .item-size {
      color: #409EFF;
      font-size: 12px;
      vertical-align: 6px;
    }

    .preview-list {
      /*.item-inline {*/
      /*.item_image {*/
      /*width: 150px;*/
      /*height: 150px;*/
      /*padding: 2px;*/

      /*&:hover, &:focus {*/
      /*border-color: #409EFF;*/
      /*}*/
      /*}*/

      /*.item_actions {*/
      /*position: absolute;*/
      /*width: 100%;*/
      /*height: 100%;*/
      /*left: 0;*/
      /*top: 0;*/
      /*cursor: default;*/
      /*text-align: center;*/
      /*color: #ffffff;*/
      /*background-color: rgba(0, 0, 0, 0.5);*/
      /*transition: opacity .3s;*/
      /*opacity: 0;*/
      /*font-size: 20px;*/

      /*span {*/
      /*cursor: pointer;*/
      /*}*/

      /*&:hover {*/
      /*opacity: 1;*/
      /*}*/

      /*&:after {*/
      /*content: '';*/
      /*width: 0;*/
      /*height: 100%;*/
      /*vertical-align: middle;*/
      /*display: inline-block;*/
      /*}*/
      /*}*/
      /*}*/

      /*.item {*/
      /*font-size: 13px;*/
      /*padding: 4px;*/

      /*.item_name {*/
      /*color: #606266;*/
      /*margin-right: 40px;*/
      /*overflow: hidden;*/
      /*padding-left: 4px;*/
      /*text-overflow: ellipsis;*/
      /*transition: color .3s;*/
      /*white-space: nowrap;*/
      /*}*/

      /*.item-size {*/
      /*color: #409EFF;*/
      /*}*/
      /*}*/
    }
  }
</style>
